import { toast } from "react-toastify";

import * as actionTypes from "../actionTypes/orderTypes";
import axios from "../../axios-instance";
import { getHeaders } from "../../helpers/getHeaders";

const getOrdersStart = () => ({
    type: actionTypes.GET_ORDER_START,
});

const getOrdersSuccess = (data) => ({
    type: actionTypes.GET_ORDER_SUCCESS,
    payload: data,
});

const getOrdersFail = (error) => ({
    type: actionTypes.GET_ORDER_FAIL,
    error,
});

export const getOrders =
    (
        userToken,
        searchQuery,
        searchByInputNumber,
        paymentStatuses,
        eventId,
        orderStatus,
        page,
        pageSize,
        sortingType,
        paymentTypes,
    ) =>
        (dispatch) => {
            dispatch(getOrdersStart());

            const bodyRequest = {
                searchQuery,
                searchByInputNumber,
                paymentStatuses,
                eventId,
                orderStatus,
                page,
                pageSize,
                sortingType,
                paymentTypes,
            };

            return axios
                .post(`/OrderManagment/List`, bodyRequest, {
                    headers: getHeaders(userToken),
                })
                .then((response) => {
                    if (response.data) {
                        return response.data;
                    }

                    throw new Error(response.data.errorMessage);
                })
                .then((result) => {
                    dispatch(getOrdersSuccess(result));
                    return result;
                })
                .catch((err) => {
                    dispatch(getOrdersFail(err));
                });
        };

export const approveOrder =
    (userToken, id, makeFiscalization, onConfirm) => (dispatch) => {
        return axios
            .post(
                `/OrderManagment/ForcePayment/${id}?makeFiscalization=${makeFiscalization}`,
                null,
                {
                    headers: getHeaders(userToken),
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    dispatch({
                        type: actionTypes.APPROVE_ORDER,
                        payload: id,
                    })
                        ;

                    onConfirm();

                    toast.success("Order successfully approved");
                    return;
                }

                throw new Error(response.data.errorMessage);
            })
            .catch((err) => {
                toast.error("Order not approved");
            });
    };

export const clearOrders = () => (dispatch) =>
  dispatch({
    type: actionTypes.CLEAR_ORDERS,
  });